import React, { useState, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import api from "../../seller-apis/api";
import "./support.css";
import { formatedDate } from "../../utilities/ConvertDateFormat";

const SupportMessageDescriptionModal = ({
  showModalDescription,
  handleCloseDesc,
  descs,
}) => {

  return (
    <Modal
      contentLabel="Large Modal"
      className="modal desc-modal"
      centered
      show={showModalDescription}
      onHide={handleCloseDesc}
    >
      {/* <a class="close message-close" onClick={() => handleCloseDesc()}>
        ×
      </a> */}
      <Modal.Header closeButton>
          <Modal.Title style={{fontSize:15}}>Description History</Modal.Title>
        </Modal.Header>
      <Modal.Body>
        <div>
          <table className="table">
            <tr>
              <th>Date</th>
              <th>Description</th>
              <th>Description By</th>
            </tr>
            {descs.map((desc, i) => {
              return <tr key={i}>
                <td>{formatedDate(desc.createdAt)}</td>
                <td>{desc.desc}</td>
                <td>{desc.descBy}</td>
              </tr>;
            })}
          </table>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default SupportMessageDescriptionModal;
